import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Layout, Avatar, Popover, Button } from "antd";
import { UserOutlined, BellOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import store from "../../store";
import { logoutUser } from "../../redux/auth";
import { useTranslation } from "react-i18next";
import moment from "moment";
let { Header } = Layout;

function getUserFromToken() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;
    return JSON.parse(atob(token.split(".")[1])); // payload JWT
  } catch {
    return null;
  }
}

export default function HeaderComponent({
  toggleSideMenu,
  showMenu,
  isMobile,
}) {
  const [color, setColor] = useState("");
  const [notifications, setNotifications] = useState(null);
  const styles = {
    color: color,
  };
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const { t, i18n } = useTranslation();

  const displayName = getUserFromToken()?.login || "";

  useEffect(() => {
    fetch("http://10.202.19.95:8080/api/data/darmen")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((result) => {
        const { notifications } = result.data.model[0];
        setNotifications(notifications);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <MyHeader>
      <div
        className="side-menu-toggle"
        onClick={() => toggleSideMenu(!showMenu)}
      >
        <img src="/img/menu.svg" />
        <span>{t("sideMenu.menu")}</span>
      </div>
      {!isMobile && (
        <>
          <LogoWrapper to="/">
            <img src="/img/new_logo.png" />
            <div
              className="text"
              onMouseEnter={() => setColor("green")}
              onMouseLeave={() => setColor("")}
            >
              {t("mainPage.information")}
            </div>
          </LogoWrapper>

          <Right>
            {/* <Popover
              placement="bottomRight"
              title={<span>Уведомления</span>}
              content={
                <div className="popover__notifications">
                  {notifications?.map((n, index) => (
                    <div key={index} className="notification">
                      <img
                        src="/img/mchs.png"
                        width={60}
                        height={60}
                        alt="МЧС"
                        style={{
                          float: "left",
                          marginRight: 10,
                          marginBottom: 6,
                        }}
                      />
                      <div>
                        <div className="popover__location">
                          {n.location_name}
                        </div>
                        <div className="popover__date">
                          {moment(n.created_at).format("DD.MM.YYYY HH:mm:ss")}
                        </div>
                        <div className="popover__title">{n.title}</div>
                        <div className="popover__text">{n.text}</div>
                      </div>
                    </div>
                  ))}
                </div>
              }
              trigger="click"
              overlayInnerStyle={{ backgroundColor: "#2f2f39", color: "white" }}
            >
              <Button icon={<BellOutlined />} style={{ marginRight: 25 }} />
            </Popover> */}
            <div style={{ marginRight: "5px" }}>
              <button
                className="language-button"
                style={{ marginRight: "8px" }}
                onClick={() => changeLanguage("ru")}
              >
                РУС
              </button>
              <button
                className="language-button"
                onClick={() => changeLanguage("kz")}
              >
                ҚАЗ
              </button>
            </div>
            <Weather>
              <div>
                <div className="city">{t("mainPage.city")}</div>
              </div>
            </Weather>
            <User>
              <Avatar icon={<UserOutlined />} />
              <div className="info">
                <div className="login">{displayName}</div>
              </div>
            </User>
            <Butt>
              <div className="nav-wrap1">
                <span onClick={() => store.dispatch(logoutUser())}>
                  {t("mainPage.exit")}
                </span>
              </div>
            </Butt>
          </Right>
        </>
      )}
    </MyHeader>
  );
}

let MyHeader = styled(Header)`
  height: 80px;
  background: #24262f;
  display: flex;
  align-items: center;
  padding: 10px 30px;
`;

let LogoWrapper = styled(Link)`
  display: flex;
  align-items: center;
  margin-left: 20px;
  img {
    margin-right: 10px;
    width: 38px;
  }
  .text {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    color: #ffffff;
    max-width: 280px;
  }
`;

let Right = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
let Butt = styled.div`
  margin-left: 20px;
  line-height: 1;
  transition: 200ms;
  cursor: pointer;
  color: white;
  padding: 10px 15px;
  background: #1a1b21;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

let Weather = styled.div`
  img {
    margin-right: 10px;
  }
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  display: flex;
  align-items: center;

  .city {
    font-size: 14px;
    line-height: 16px;
    color: #ffffffb3;
  }
`;

let User = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #fff;
  .info {
    margin-left: 10px;
    line-height: normal;
  }
  .info .login {
    font-size: 14px;
    line-height: 16px;
    color: #ffffffb3;
  }
`;
